import { Fragment } from 'react';
import * as permifyConstants from '../../../../../../../api/src/permify/constants';
import { Submission } from '@repo/api/open-calls/graphql';

export type CandidateInfoAboutRow = {
  label: string;
  requiresCandidateInfoPermission?: boolean;
  value?: string | number | null;
};

export type CandidateInfoAboutConfig = {
  getRows: (candidate: Submission) => CandidateInfoAboutRow[];
  title: string;
};

type CandidateInfoAboutProps = {
  aboutConfig: CandidateInfoAboutConfig;
  candidate: Submission;
};

export function CandidateInfoAbout({
  aboutConfig,
  candidate,
}: CandidateInfoAboutProps) {
  const rows = aboutConfig.getRows(candidate);

  return (
    <div className="bg-white">
      <div className="px-4 py-6 md:text-lg font-bold">{aboutConfig.title}</div>
      <div className="grid grid-cols-[168px,1fr]">
        {rows.map((row, index) => {
          const permission = row.requiresCandidateInfoPermission
            ? permifyConstants.permissions.openCalls.viewCandidateInfo
            : undefined;
          const value =
            row.value === undefined || row.value === null || row.value === ''
              ? '-'
              : row.value;

          return (
            <Fragment key={`${row.label}-${index}`}>
              <div
                className="p-4 border-b border-zinc-100"
                data-permission={permission}
              >
                {row.label}
              </div>
              <div
                className="p-4 border-b border-zinc-200"
                data-permission={permission}
              >
                {value}
              </div>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}
